import {matchPath} from "react-router-dom";

// Browser-tab titles for the customer/cleaner app. One place for every route so
// the <title> (the browser tab name) is correct on every page instead of the
// static index.html fallback. Set on navigation by <TitleManager/>.

export const BRAND = "Kova";

// Ordered [path pattern, title] pairs. Patterns use react-router syntax
// (":id" params). `end: true` means each is matched exactly, so more/less
// specific routes never collide (e.g. "/support" vs "/support/chat/:id").
const TITLES = [
    ["/main", "Мої замовлення"],
    ["/create-order", "Створення замовлення"],
    ["/create-order/step-1", "Адреса"],
    ["/create-order/step-2", "Вибір послуги"],
    ["/create-order/step-3", "Деталі послуги"],
    ["/create-order/step-4", "Дата й час"],
    ["/create-order/step-5", "Ваші дані"],
    ["/completed-orders", "Історія замовлень"],
    ["/completed-orders/:id", "Деталі замовлення"],
    ["/settings", "Налаштування"],
    ["/order-details/:id", "Замовлення"],
    ["/payment", "Оплата"],
    ["/all-cleaning-requests", "Пошук замовлень"],
    ["/orders", "Активні замовлення"],
    ["/cleaner-application/:id", "Подана заявка"],
    ["/cleaner-applications", "Мої заявки"],
    ["/cleaning-request/:id", "Замовлення"],
    ["/order/:id", "Замовлення"],
    ["/feedback", "Відгук"],
    ["/support", "Підтримка"],
    ["/support/chat/:id", "Чат із підтримкою"],
    ["/registration/customer", "Реєстрація"],
    ["/registration/cleaner", "Реєстрація клінера"],
    ["/login", "Вхід"],
    ["/restore-password-step-1", "Відновлення пароля"],
    ["/restore-password-step-2", "Відновлення пароля"],
    ["/restore-password-step-3/:token", "Відновлення пароля"],
    ["/restore-password-step-4", "Відновлення пароля"],
    ["/qr/:session_id", "Завантаження фото"],
];

// Resolve the browser-tab title for a pathname. Falls back to a branded default
// (unknown routes, the 404 page).
export function getPageTitle(pathname) {
    for (const [pattern, title] of TITLES) {
        if (matchPath({path: pattern, end: true}, pathname)) {
            return `${title} — ${BRAND}`;
        }
    }
    return `${BRAND} — клінінг сервіс`;
}
